import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/builds/nocowaniedev/frontend/frontend/apps/nocowanie-ssr/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager", webpackExports: ["createIcon"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/components/icon/create-icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSlotRecipe"] */ "/builds/nocowaniedev/frontend/frontend/node_modules/@chakra-ui/react/dist/esm/styled-system/use-slot-recipe.js");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/builds/nocowaniedev/frontend/frontend/node_modules/next/dist/client/script.js");
